export const GET_STORIES = "getStories";
export const GET_USER_STORIES = "getUserStories";
export const HAS_MORE = "hasMore";
